import { exists } from '@/api'
import { dateToPlainFormat } from '@/utils'

export interface SystemUser {
  id: number
  userId: string
  passwordExpirationDate: string
  name: string
  isActive: boolean
  groupId: number
  groupName: string
  authFailureLimitCount: number
  note: string
  canEdit: boolean
  revision: number
}

export const defaultSystemUser = (): SystemUser => ({
  id: 0,
  userId: '',
  passwordExpirationDate: '',
  name: '',
  isActive: false,
  groupId: 0,
  groupName: '',
  authFailureLimitCount: 0,
  note: '',
  canEdit: false,
  revision: 0
})

export function SystemUserFromJSON(json: any): SystemUser {
  return {
    id: exists(json, 'id') ? json.id : 0,
    userId: exists(json, 'user_id') ? json.user_id : '',
    passwordExpirationDate: exists(json, 'password_expiration_date')
      ? dateToPlainFormat(json.password_expiration_date)
      : '',
    name: exists(json, 'name') ? json.name : '',
    isActive: exists(json, 'is_active') ? json.is_active : false,
    groupId: exists(json, 'group_id') ? json.group_id : 0,
    groupName: exists(json, 'group_name') ? json.group_name : '',
    authFailureLimitCount: exists(json, 'auth_failure_limit_count')
      ? json.auth_failure_limit_count
      : 0,
    note: exists(json, 'note') ? json.note : '',
    canEdit: exists(json, 'can_edit') ? json.can_edit : false,
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
